/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ReportTypeModel } from '../models/report-type-model';

@Injectable({
  providedIn: 'root',
})
export class ReportTypesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAllReportTypes
   */
  static readonly GetAllReportTypesPath = '/api/report-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllReportTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllReportTypes$Response(params?: {
    vehicleTypeId?: number;
    companyId?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<ReportTypeModel>>> {

    const rb = new RequestBuilder(this.rootUrl, ReportTypesService.GetAllReportTypesPath, 'get');
    if (params) {
      rb.query('vehicleTypeId', params.vehicleTypeId, {});
      rb.query('companyId', params.companyId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ReportTypeModel>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllReportTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllReportTypes(params?: {
    vehicleTypeId?: number;
    companyId?: string;
    context?: HttpContext
  }
): Observable<Array<ReportTypeModel>> {

    return this.getAllReportTypes$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ReportTypeModel>>) => r.body as Array<ReportTypeModel>)
    );
  }

}
